import { Model } from "@/models/base/Model";
import { v4 as uuid } from "uuid";



class PaginationModel extends Model  {
    current_page?: number;;
    from?: number;
    total?: number;
    to?: number;
    per_page?: number;
    last_page?: number;

    constructor(data = null) {
        super(data);
        if(data) {
            this.createModel(data);
        }
    }
}

export default PaginationModel  ; 